import ProductSelectControllerSignal from '@/product/product-select-controller';
import {cartData} from '@/cart/tests/fixtures';
import {createContext} from 'preact';
import defaultProductSelectSettings from '@/settings/placeholder/product-select';

/**
 * This is a fallback controller for testing purposes.
 * In production, it will be replaced by the actual controller.
 */
const mockController = new ProductSelectControllerSignal({
  cart: {
    addLineItems: () => Promise.resolve(),
    loadCart: () => Promise.resolve(cartData),
  },
  deliveryOptions: [],
  productId: '123',
  products: {getProduct: () => null},
  settings: defaultProductSelectSettings,
});

const ProductSelectController = createContext(mockController);

export default ProductSelectController;
